import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
const painPoints = ['Tu perro se rasca, se lame las patas y ya no sabés qué hacer', 'Algo no está bien en su salud y sospechás que es la comida', 'Querés cambiar su alimentación pero tenés miedo de hacerlo mal', 'Sentís que otras dueñas ya saben cómo cuidar mejor a sus perros y vos todavía no', 'Sentís culpa porque querés lo mejor para él pero no sabés cómo dárselo'];
export function ProblemSection() {
  return <section className="py-8 md:py-10 px-4 bg-lightgreen" data-id="element-145">
      <div className="max-w-2xl mx-auto" data-id="element-146">
        {/* Inner card container */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white/80 backdrop-blur-sm rounded-3xl border border-sage/60 shadow-[0_4px_32px_rgba(0,0,0,0.06)] px-5 py-7 md:px-8 md:py-9" data-id="element-147">
          {/* Title */}
          <div className="text-center mb-6" data-id="element-148">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent/10 mb-3" data-id="element-149">
              <AlertTriangleIcon className="w-5 h-5 text-accent" data-id="element-150" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif text-charcoal leading-tight mb-2" data-id="element-151">
              Tu perro podría estar{' '}
              <span className="text-primary text-[1.15em] font-extrabold uppercase tracking-wide" data-id="element-152">
                enfermando
              </span>
              <br data-id="element-153" />
              por lo que come...
            </h2>
            <p className="text-lg md:text-xl font-semibold text-accent" data-id="element-154">
              Y tú ni siquiera lo sabés
            </p>
            <div className="w-16 h-1 bg-accent mx-auto rounded-full mt-3" data-id="element-155"></div>
          </div>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="text-center text-xl md:text-2xl font-bold text-charcoal mb-6" data-id="element-156">
            Este ebook es para vos si...
          </motion.p>

          {/* Pain Point Cards */}
          <div className="flex flex-col gap-3 mb-7" data-id="element-157">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.35,
            delay: 0.15 + index * 0.08
          }} className="flex items-start gap-3 bg-[#FFF0F0] rounded-xl px-4 py-3.5" data-id="element-158">
                <span className="text-[#E05555] text-lg flex-shrink-0 mt-0.5" data-id="element-159">
                  ❌
                </span>
                <span className="text-sm md:text-base text-gray-700 leading-snug" data-id="element-160">
                  {point}
                </span>
              </motion.div>)}
          </div>

          {/* Closing Message */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="rounded-2xl border border-primary/20 px-5 py-5 md:px-6 md:py-6 max-w-xl mx-auto text-center bg-[#F8F6F3]" data-id="element-161">
            <p className="text-xl md:text-2xl font-extrabold text-primary leading-snug" data-id="element-162">
              No sos mala dueña.
              <br data-id="element-163" />
              <span className="text-gray-600 font-semibold" data-id="element-164">
                Solo nadie te enseñó cómo hacerlo bien.
              </span>
              <br data-id="element-165" />
              <span className="text-accent text-[1.1em] font-black uppercase tracking-wide" data-id="element-166">
                Hasta hoy.
              </span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}